export default __webpack_public_path__ + "static/media/clap.ceba0529.png";